import { Alpine as AlpineType } from 'alpinejs';

export default (Alpine: AlpineType) => {
  Alpine.data('search', () => ({

    async input(e: any) {
      const url = e.target.value
        ? `/search?q=${e.target.value}&type=product&options[unavailable_products]=hide`
        : '/search';

      const html = document.createElement('div');
      html.innerHTML = await fetch(url, { method: 'GET' }).then((response) => response.text());

      this.$refs.searchResults.innerHTML = html.querySelector('[search-results]')?.innerHTML || '';

      history.replaceState({}, "", url);
    }
  }));
};
